import Helper from './Helper';

class InteractiveSVGTriggerTarget {
  constructor() {
    this.trigger = document.querySelectorAll('g[id^="trigger-"]');
    this.triggers = Array.prototype.slice.call(this.trigger);
    this.target = document.querySelectorAll('g[id^="target-"]');
    this.targets = Array.prototype.slice.call(this.target);
    this.triggerClose = document.querySelectorAll('g[id^="triggerclose-"]');
    this.triggerCloses = Array.prototype.slice.call(this.triggerClose);


    this.bindEvents();
  }

  bindEvents() {
    this.triggerCloses.forEach(el => {
      let id = el.getAttribute('id').split('-')[1];
      el.addEventListener('click', event => {
        this.closeAll();
      });
    });

    this.triggers.forEach(el => {
      let id = el.getAttribute('id').split('-')[1];
      el.addEventListener('click', event => {
        console.log('clicked');
        this.closeAll();
        this.hideTrigger(id);
        this.openTarget(id);
        this.showTriggerClose(id);
      });
    });
  }

  openTarget(targetId) {
    let id = targetId;
    let target = 'target-'+id;

    this.targets.forEach(el => {
      if(el.getAttribute('id') === target) {
        el.classList.add('active');
      }
    });
  }

  closeTarget(targetId) {
    let id = targetId;
    let target = 'target-'+id;

    this.targets.forEach(el => {
      if(el.getAttribute('id') === target) {
        el.classList.add('active');
      }
    });
  }

  hideTrigger(targetId) {
    let id = targetId;
    let trigger = 'trigger-'+id;

    this.triggers.forEach(el => {
      if(el.getAttribute('id') === trigger) {
        el.classList.add('inactive');
      }
    });
  }

  showTriggerClose(targetId) {
    let id = targetId;
    let triggerClose = 'triggerclose-'+id;

    this.triggerCloses.forEach(el => {
      if(el.getAttribute('id') === triggerClose) {
        el.classList.add('active');
      }
    });
  }

  hideTriggerClose(targetId) {
    let id = targetId;
    let triggerClose = 'triggerclose-'+id;

    this.triggerCloses.forEach(el => {
      if(el.getAttribute('id') === triggerClose) {
        el.classList.remove('active');
      }
    });
  }

  closeAll() {
    this.targets.forEach(el => {
      el.classList.remove('active');
    });

    this.triggers.forEach(el => {
      el.classList.remove('inactive');
    });

    this.triggerCloses.forEach(el => {
      el.classList.remove('active');
    });
  }
}

export default InteractiveSVGTriggerTarget;
